/**
 * Assets: Collection
 * -----------------------------------------------------------------------------
 * - Clear Boost loading skeleton.
 * - Render colour swatches.
 * - Render collection grid banner.
 * - Render Yotpo ratings.
 *
 */
document.addEventListener('DOMContentLoaded', () => {
  afterRender()
  updateFilterPosition()
  boostWidgetIntegration.regisCustomization(afterRender)
})

/**
 * Boost callback function.
 */
function afterRender() {
  waitForElement('[js-collection="productList"]', () => {
    renderBoost()
    renderColourSwatches()
    renderCollectionGridBanner()
    handleAddToCart()

    /**
     * Wait for Yotpo to load before rendering ratings.
     */
    const yotpoCheck = setInterval(() => {
      if (!window.yotpo) {
        return
      }

      clearInterval(yotpoCheck)
      renderYotpoRating()
    }, 200)
  })
}

function handleAddToCart() {
  const productCards = document.querySelectorAll('.boost-sd__product-item')
  const cartDrawer = document.querySelector('cart-drawer')
  const mobileVariantDialog = document.querySelector('.mod_MobileVariantDialog')
  const sections = cartDrawer.getSectionsToRender().map((section) => section.id)

  mobileVariantDialog.addEventListener('click', e => {
    const rect = mobileVariantDialog.getBoundingClientRect()
    const isInDialog =
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom
    if (!isInDialog) mobileVariantDialog.close()
  })

  productCards.forEach((card) => {
    const atcButtons = card.querySelectorAll('.boost-sd__button')

    atcButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopImmediatePropagation()

          btn.classList.add('is-busy')

          const { product: rawData } = card.dataset
          const product = JSON.parse(rawData)

          const variants = productVariants(product)

          if (variants.length > 1) {
            
          if (product && product.handle) {
            const pickerContainer = card.querySelector('.boost-sd__popup-select-option')
            
            
            fetch(`${routes.products_url}/${product.handle}/?section_id=section-variant-picker`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html')
              const source = html.querySelector('#variant-picker')

              const mql = window.matchMedia('(min-width: 990px)')

              if (mql.matches) {
                pickerContainer.innerHTML = source.innerHTML
                pickerContainer.style.display = 'block'
              } else {
                mobileVariantDialog.innerHTML = source.innerHTML
                mobileVariantDialog.showModal()
              }
            })
            .catch((e) => {
              console.error(e)
            })
            .finally(() => {
              btn.classList.remove('is-busy')
            })
          }
          } else {
            const id = variants[0]?.id

            if (! id) {
              console.error('No variant available to add to cart')
              return               
            }

            btn.classList.add('is-busy')
            
            const body = JSON.stringify({ sections, items: [{ quantity: 1, id }]})
            fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), ...{ body } })
            .then( response => response.text())
            .then( state => {
              const parsedState = JSON.parse(state)
              if (cartDrawer && !cartDrawer.isActive()) {
                cartDrawer.renderContents(parsedState)
              }
            })
            .finally((e) => {
                btn.classList.remove('is-busy')
            })        
          }
      })
    })
  })
}

 function getfirstAvailableVariantId(product) {
    try {
      const variants = JSON.parse(product.variants)

      if (variants) {
        const firstAvailableVariant = variants.filter( variant => variant.available)[0]
        return firstAvailableVariant.id
      }
    } catch(err) {
      return null
    }
  }

  function productVariants(product) {
    try {
      const variants = JSON.parse(product.variants)

      if (variants) {
        return variants.filter( variant => variant.available)
      }
    } catch(err) {
      return null
    }
  }

/**
 * Wait for element to exist.
 */
function waitForElement(selector, callback) {
  const intervalId = setInterval(() => {
    if (document.querySelector(selector)) {
      clearInterval(intervalId)
      callback()
    }
  }, 200)
}

/**
 * Render Boost.
 * - Toggle visibility of loading skeleton and Boost elements.
 */
function renderBoost() {
  document.body.classList.add('boost-active')

  const skeleton = document.querySelector('[js-collection="skeleton"]')

  if (skeleton) {
    skeleton.classList.add('is-hidden')
  }
}

/**
 * Render Yotpo rating.
 */
function renderYotpoRating() {
  const productCardsContainer = document.querySelector('[js-collection="productList"]')
  const productCards = [...productCardsContainer.querySelectorAll('[js-collection="productCard"]')]

  if (!productCards.length || window.renderingYotpo) {
    return
  }

  window.renderingYotpo = true

  /**
   * Refresh widgets to render them.
   */
  setTimeout(() => {
    window.yotpo.refreshWidgets()
  }, 0)

  /**
   * Check to see if widget has rendered before showing/hiding skeleton.
   */
  const ratingCheck = setInterval(() => {
    const yotpoElement = productCards.find((productCard) => {
      return productCard.querySelector('.yotpo-widget-instance .yotpo-reviews-star-ratings-widget')
    })

    if (!yotpoElement) {
      return
    }

    clearInterval(ratingCheck)

    setTimeout(() => {
      productCardsContainer.classList.add('yotpo-loaded')
      window.renderingYotpo = false
    }, 200)
  }, 100)
}

/**
 * Render colour swatches.
 */
async function renderColourSwatches() {
  const productCardsContainer = document.querySelector('[js-collection="productList"]')
  const productCards = [...productCardsContainer.querySelectorAll('[js-collection="productCard"]')]

  if (!productCards.length) {
    productCardsContainer.classList.add('swatches-loaded')
    return
  }

  productCards.forEach(async(productCard) => {
    let swatchesExist = productCard.querySelector('[js-colour-swatches="container"]')

    /**
     * If swatches already exist then ignore.
     */
    if (swatchesExist) {
      productCard.classList.add('swatches-loaded')
      return
    }

    /**
     * Query colour swatches section data.
     */
    const productCardData = productCard.dataset.product && JSON.parse(productCard.dataset.product)
    const response = await fetch(`/products/${productCardData.handle}?section_id=colour-swatches`)

    if (!response.ok) {
      console.error(new Error(response.status))
      return
    }

    /**
     * Convert to HTML and find swatches in section.
     */
    const responseText = await response.text()
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const newSwatches = html.querySelector('[js-colour-swatches="container"]')

    /**
     * Append new swatches to container.
     * - Check again to see if swatches exist after query.
     */
    const swatchesContainer = productCard.querySelector('[js-colour-swatches="productColourSwatches"]')
    swatchesExist = productCard.querySelector('[js-colour-swatches="container"]')

    if (!newSwatches || !swatchesContainer || swatchesExist) {
      productCard.classList.add('swatches-loaded')
      return
    }

    swatchesContainer.append(newSwatches)
    productCard.classList.add('swatches-loaded')
  })
}

/**
 * Update Boost mobile sticky filter position.
 */
function updateFilterPosition() {
  const checkToolbarItem = setInterval(function() {
    const toolbarItem = document.querySelector('.boost-sd__toolbar-item.boost-sd__toolbar-item--sorting');

    if (toolbarItem) {
      adjustFilterPosition()
      clearInterval(checkToolbarItem)
    }
  }, 100)

  window.addEventListener('resize', debounce(adjustFilterPosition, 50))
}

/**
 * Update sticky filter position.
 */
function adjustFilterPosition() {
  const header = document.querySelector('.site-header-group-sticky')
  const toolbarItem = document.querySelector('.boost-sd__toolbar-item.boost-sd__toolbar-item--sorting');

  if (!toolbarItem) {
    return
  }

  const headerHeight = header.offsetHeight
  toolbarItem.style.top = `${headerHeight}px`
}

/**
 * Debounce function.
 * @param {Function} callback - Callback function.
 * @param {Number} wait - Wait duration in ms.
 * @returns {Function}
 */
function debounce(callback, wait) {
  let timeout

  return function() {
    clearTimeout(timeout)
    timeout = setTimeout(callback, wait)
  }
}

/**
 * Collection grid banner.
 * -----------------------------------------------------------------------------
 * Functions to handle rendering of collection grid banner.
 *
 */

/**
 * Render collection grid banner.
 */
function renderCollectionGridBanner() {
  const productCardsContainer = document.querySelector('[js-collection="productList"]')

  if (typeof window.collectionGridBannerData === 'undefined') {
    return
  }

  const bannerElementContainer = productCardsContainer.querySelector('[js-collection="gridBannerContainer"]')
  bannerElementContainer.innerHTML = collectionGridBannerHtml()
  hideGridBanner()
  handleContentContainer()
}

/**
 * Collection grid banner html.
 * @returns {String}
 */
function collectionGridBannerHtml() {
  let bannerHTML = ''

  if (window.collectionGridBannerData.link.url) {
    bannerHTML += `
      <a
        class="collection__grid-banner-cta"
        href="${window.collectionGridBannerData.link.url}"
      ></a>
    `
  }

  bannerHTML += `
    <div>
      ${renderMedia()}

      <div class="collection__grid-banner-content-container">
        ${renderTitleHtml()}
        ${renderContentHtml()}
        ${renderLinkHtml()}
      </div>
    </div>
  `

  return bannerHTML
}

/**
 * Render media.
 * @returns {String}
 */
function renderMedia() {
  return window.collectionGridBannerData.media.media_type === 'video'
    ? mediaVideoHtml()
    : mediaImageHtml()
}

/**
 * Media video html.
 * @returns {String}
 */
function mediaVideoHtml() {
  const videoHtml = `
    <video
      class="collection__grid-banner-video video-js"
      ${window.collectionGridBannerData.mediaVideoAutoplay ? 'autoplay' : ''}
      ${window.collectionGridBannerData.mediaVideoLoop ? 'loop' : ''}
      playsinline
      muted
      poster="${window.collectionGridBannerData.media.preview_image.src}"
    >
      ${renderMediaVideoSrcHtml()}
    </video>
  `

  return `
    <video-player class="video-player">
      ${videoHtml}
      ${playButtonHtml()}
      ${pauseButtonHtml()}
      ${muteButtonHtml()}
      ${unmuteButtonHtml()}
    </video-player>
  `
}

/**
 * Media image html.
 * @returns {String}
 */
function mediaImageHtml() {
  const imageHtml = `
    <img
      class="collection__grid-banner-image"
      src="${window.collectionGridBannerData.media}"
    >
  `

  return imageHtml
}

/**
 * Render media video src html.
 * @returns {String}
 */
function renderMediaVideoSrcHtml() {
  return getMediaVideoSrc()
    .map((source) => `<source src="${source.url}" type="${source.mime_type}">`)
    .join('')
}

/**
 * Get media video src.
 * - If `window.collectionGridBannerData.media.sources` is provided, processes sources
 *   array to grab the m3u8 format source and the largest mp4 format source and
 *   return those sources.
 * @returns {Array}
 */
function getMediaVideoSrc() {
  if (!window.collectionGridBannerData.media?.sources?.length) {
    return []
  }

  const sources = [...window.collectionGridBannerData.media?.sources]
  const outputSources = []

  const mp4Sources = sources.filter((source) => source.format === 'mp4')
  const m3u8Source = sources.find((source) => source.format === 'm3u8')

  const largestMp4Source = mp4Sources.reduce((previous, current) => {
    return current.width > previous.width ? current : previous
  }, mp4Sources[0])

  if (m3u8Source) {
    outputSources.push(m3u8Source)
  }

  if (largestMp4Source) {
    outputSources.push(largestMp4Source)
  }

  return outputSources
}

/**
 * Play button html.
 * @returns {String}
 */
function playButtonHtml() {
  return `
    <button
      class="
        collection__grid-banner-play-button
        video-player__play-button
        ${window.collectionGridBannerData.mediaVideoAutoplay ? 'is-hidden' : ''}
        button-reset
      "
      aria-label="${window.accessibilityStrings.playButton}"
      js-video-player="play"
    >
      <svg class="icon icon-play" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 46 45">
        <rect width="44" height="44" x="1" y=".5" stroke="currentColor" rx="22"/>
        <path fill="currentColor" d="m19.25 16.667 9.167 5.833-9.167 5.833V16.667Z"/>
      </svg>
    </button>
  `
}

/**
 * Pause button html.
 * @returns {String}
 */
function pauseButtonHtml() {
  return `
    <button
      class="
        collection__grid-banner-pause-button
        video-player__pause-button
        ${!window.collectionGridBannerData.mediaVideoAutoplay ? 'is-hidden' : ''}
        button-reset
      "
      aria-label="${window.accessibilityStrings.pauseButton}"
      js-video-player="pause"
    >
      <svg class="icon icon-pause" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 46 46">
        <rect width="44" height="44" x="1" y="1" stroke="currentColor" rx="22"/>
        <path fill="currentColor" fill-rule="evenodd" d="M19.25 28V18h1.667v10H19.25ZM25.083 28V18h1.667v10h-1.667Z" clip-rule="evenodd"/>
      </svg>
    </button>
  `
}

/**
 * Mute button html.
 * @returns {String}
 */
function muteButtonHtml() {
  return `
    <button
      class="
        collection__grid-banner-mute-button
        video-player__mute-button
        is-hidden
        button-reset
      "
      aria-label="${window.accessibilityStrings.mute_button}"
      js-video-player="mute"
    >
      <svg class="icon icon-unmute" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24">
        <path fill="currentColor" d="m11.5 5-5 4h-4v6h4l5 4V5Z"/>
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M19.57 4.93a10 10 0 0 1 0 14.14M16.04 8.46a5 5 0 0 1 0 7.07"/>
      </svg>
    </button>
  `
}

/**
 * Unmute button html.
 * @returns {String}
 */
function unmuteButtonHtml() {
  return `
    <button
      class="
        collection__grid-banner-unmute-button
        video-player__unmute-button
        button-reset
      "
      aria-label="${window.accessibilityStrings.unmute_button}"
      js-video-player="unmute"
    >
      <svg class="icon icon-mute" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24">
        <path fill="currentColor" fill-rule="evenodd" d="M11.717 4.55A.5.5 0 0 1 12 5v14a.5.5 0 0 1-.812.39L6.325 15.5H2.5A.5.5 0 0 1 2 15V9a.5.5 0 0 1 .5-.5h3.825l4.863-3.89a.5.5 0 0 1 .529-.06ZM11 6.04 6.812 9.39a.5.5 0 0 1-.312.11H3v5h3.5a.5.5 0 0 1 .312.11L11 17.96V6.04ZM23.854 8.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0Z" clip-rule="evenodd"/>
        <path fill="currentColor" fill-rule="evenodd" d="M17.146 8.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708Z" clip-rule="evenodd"/>
      </svg>
    </button>
  `
}

/**
 * Render title html.
 * @returns {String}
 */
function renderTitleHtml() {
  if (!window.collectionGridBannerData.title) {
    return ''
  }

  let style = ''

  if (window.collectionGridBannerData.titleColour) {
    style = `color: ${window.collectionGridBannerData.titleColour}`
  }

  let fontClass = ''

  fontClass += window.collectionGridBannerData.titleMobileSize
    ? `${window.collectionGridBannerData.titleMobileSize}-mobile `
    : 'h3-mobile '

  fontClass += window.collectionGridBannerData.titleDesktopSize
    ? `${window.collectionGridBannerData.titleDesktopSize}-desktop`
    : 'h3-desktop'

  return `
    <div
      class="collection__grid-banner-title ${fontClass}"
      style="${style}"
    >
      ${window.collectionGridBannerData.title}
    </div>
  `
}

/**
 * Render content html.
 * @returns {String}
 */
function renderContentHtml() {
  if (!window.collectionGridBannerData.content) {
    return ''
  }

  let style=''

  if (window.collectionGridBannerData.contentColour) {
    style = `color: ${window.collectionGridBannerData.contentColour}`
  }

  return `
    <div
      class="collection__grid-banner-content body-2"
      style="${style}"
    >
      ${window.collectionGridBannerData.content}
    </div>
  `
}

/**
 * Render link html.
 * @returns {String}
 */
function renderLinkHtml() {
  if (!window.collectionGridBannerData.link) {
    return ''
  }

  return `
    <div class="collection__grid-banner-link-container">
      <a
        class="
          collection__grid-banner-link
          button
          button--secondary
          button--secondary-outline
        "
        href="${window.collectionGridBannerData.link.url}"
      >
        ${window.collectionGridBannerData.link.text}
      </a>
    </div>
  `
}

/**
 * Hide grid banner.
 */
function hideGridBanner() {
  const productCardsContainer = document.querySelector('[js-collection="productList"]')
  const productCards = document.querySelectorAll('[js-collection="productCard"]')

  if (productCards?.length < 8) {
    productCardsContainer.classList.add('hide-grid-banner-mobile')
  }

  if (productCards?.length < 7) {
    productCardsContainer.classList.add('hide-grid-banner-desktop')
  }
}

/**
 * Handle content container.
 * - Add class to content container when no link exists.
 */
function handleContentContainer() {
  const contentContainer = document.querySelector('.collection__grid-banner-content-container')

  if (!window.collectionGridBannerData.link && contentContainer) {
    contentContainer.classList.add('collection__grid-banner-content-container--no-link-exist')
  }
}
